import { render } from "./dialog3.vue?vue&type=template&id=47328722&scoped=true"
import script from "./dialog3.vue?vue&type=script&lang=js"
export * from "./dialog3.vue?vue&type=script&lang=js"

import "./dialog3.vue?vue&type=style&index=0&id=47328722&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47328722"]])

export default __exports__